import L from 'leaflet';

export function mergeRefs(...refs) {
  return (value) => {
    for (let ref of refs) {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref) {
        ref.current = value;
      }
    }
  };
}

export const calculateDistanceBetweenTwoPoints = (positionA, positionB) => {
  const pointA = L.latLng(positionA?.[0], positionA?.[1]);
  const pointB = L.latLng(positionB?.[0], positionB?.[1]);
  const distanceInMeters = pointA.distanceTo(pointB);
  return distanceInMeters.toFixed(2);
};

export const calculateCenterPoint = (position1, position2) => {
  const lat1 = position1[0];
  const lon1 = position1[1];
  const lat2 = position2[0];
  const lon2 = position2[1];

  const centerLat = (lat1 + lat2) / 2;
  const centerLon = (lon1 + lon2) / 2;

  return [centerLat, centerLon];
};
